import { render, staticRenderFns } from "./PlaceModal.vue?vue&type=template&id=6009e407&"
import script from "./PlaceModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlaceModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6009e407')) {
      api.createRecord('6009e407', component.options)
    } else {
      api.reload('6009e407', component.options)
    }
    module.hot.accept("./PlaceModal.vue?vue&type=template&id=6009e407&", function () {
      api.rerender('6009e407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/PlaceFilters/components/PlaceModal.vue"
export default component.exports